import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { LotsManagementDetailCrumbs } from 'front-office/constants/lots-management-crumbs';
import { Card, CardActions, CardContent, Typography, useEventCallback } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormEdit from 'front-office/components/lots-management/edit';
import { Form, Formik } from 'formik';
import { validationSchemaEdit } from 'front-office/constants/lots-management-schema';
import { PmiButton } from 'shell/components/shared/button';
import { LotsManagementEditVM } from 'front-office/view-models/lots-management/edit';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseLotsManagement } from 'shell/models/lots-management';
import { transformerLotsManagementDataEdit } from 'front-office/utils/transformer-lots-management';
import { noop } from 'shell/utils/noop';

const LotsManagementDetail = (): ReactElement => {
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  const dataAssegnazione = queryParams.get('dataAssegnazione') || '';
  const oraAssegnazione = queryParams.get('oraAssegnazione') || '';
  const ente = queryParams.get('ente') || '';
  const operatore = queryParams.get('operatore') || '';
  const servizio = queryParams.get('servizio') || '';

  const [lots] = useHttpFetch<HttpResponse<ResponseLotsManagement>, LotsManagementEditVM>(
    `${__PERSON_API_URL__}/persona/lotto-carte/lotto-cid`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          dataAssegnazione,
          oraAssegnazione,
          ente,
          operatore,
          servizio,
        },
      },
      transformer: transformerLotsManagementDataEdit,
    }
  );

  const onCancel = useEventCallback(() => {
    navigate('/sportello/gestione-lotti');
  });

  return (
    <Fragment>
      <Breadcrumbs items={LotsManagementDetailCrumbs} />
      {lots.data ? (
        <Card raised className="pmi-my-3">
          <Formik
            validationSchema={validationSchemaEdit}
            initialValues={lots.data as LotsManagementEditVM}
            onSubmit={noop}
          >
            <Form>
              <CardContent style={{ padding: '24px' }}>
                <Typography gutterBottom variant="h5" component="h2">
                  Modifica lotto
                </Typography>
                <div style={{ padding: '24px 0 0 0' }}>
                  <FormEdit disabled />
                </div>
              </CardContent>
              <CardActions style={{ padding: '24px 24px 16px 24px' }}>
                <PmiButton variant="contained" color="primary" type="submit" disabled>
                  Conferma
                </PmiButton>
                <PmiButton
                  variant="outlined"
                  color="cdmBrand"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  Esci
                </PmiButton>
              </CardActions>
            </Form>
          </Formik>
        </Card>
      ) : undefined}
    </Fragment>
  );
};

LotsManagementDetail.displayName = 'Lots Management Detail Page component';

export default LotsManagementDetail;
